export default __webpack_public_path__ + "static/media/arrow4.4ba9efb7.svg";